module.exports = __webpack_public_path__ + "img/product-ketang-jbg-07.0ced33b8.png";